import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'name'
})
export class NamePipe implements PipeTransform {

  transform(value: string, part: 'first' | 'last'): string {

    let parts: string[] = value.replace(/([ ]+)/g, ' ').trim().split(' ');

    switch (part) {
      case 'first': return parts[0];
      case 'last': return parts[parts.length - 1];
    }
  }

}
